export const liensFooterLogin = [
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_accessibilite/',
    label: "Niveau d'accessibilité: partiellement conforme",
  },
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_mentions_legales',
    label: 'Mentions légales',
  },
]

export const liensFooterCEJ = [
  liensFooterLogin[0],
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_conditions_generales',
    label: "Conditions Générales d'Utilisation",
  },
  liensFooterLogin[1],
  {
    url: 'https://travail-emploi.gouv.fr/application-contrat-dengagement-jeune-cej-traitement-des-donnees-personnelles',
    label: 'Politique de confidentialité',
  },
]

export const liensFooterPassEmploi = [
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_pass_emploi_accessibilite/',
    label: "Niveau d'accessibilité: non conforme",
  },
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_pass_emploi_conditions_generales',
    label: "Conditions Générales d'Utilisation",
  },
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/pass_emploi_mentions_legales/',
    label: 'Mentions légales',
  },
  {
    url: 'https://doc.pass-emploi.beta.gouv.fr/legal/web_pass_emploi_politique_de_confidentialite',
    label: 'Politique de confidentialité',
  },
]
